import { AlignSelfType } from 'common/types/styleTypes'

export const alignSelfVariants: Record<string, AlignSelfType> = {
  flexStart: 'flex-start',
  center: 'center',
  flexEnd: 'flex-end',
}
